import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { showErrorInNotification, getDownloadedFile } from '../../lib/util';
import Axios from 'axios';
import { Spin, Row, Button, Badge, Tooltip, Table, Divider, message, Tag } from 'antd';
import ErrorWrapper from '../../lib/error_wrapper';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
// import FileViewer from 'react-file-viewer';
import moment from 'moment';
import { BasicHeader } from '../../components/basic_header';
import { TransparentButton } from '../../components/basic_items';
import { CloudDownloadOutlined, RestoreFromTrashOutlined, ArchiveOutlined, UnarchiveOutlined } from '@material-ui/icons';
import { COLORS } from '../theme';
import DebugFilePreview from '../../components/debug_file_preview';


var FileSaver = require('file-saver');



class ReportDetail extends Component {
  constructor(props) {
    super(props)

    this.report_id = props.match.params.report_id;
    this.state = {
      detail_loading: true,
      file_loading: true,
      file_loading_error:false,
      downloaded_file: null,
      report_detail: {},
      xls_data: {},
      archived: false,
      url:null
    };


    this.get_file_url=RESTExecutor.detail().config({
      label:'download_report'
    }).callbacks((success)=>{

    }).connect(props.domains.reports);


    // this.download_report = RESTExecutor.detail().config({
    //   label: 'download_report'
    // }).callbacks((success) => {
    //   console.log("download url", success)
    //   // window.open(success.result.url, '_blank');
    //   this.download_url = success.result.url;

    //   getDownloadedFile(`${success.result.url}`)
    //     .then((file) => {
    //       console.log("got file", file);
    //       ExcelRenderer(file, (err, resp) => {
    //         if(err){
    //           console.log(err);            
    //         }
    //         else{
    //           this.setState({
    //             cols: resp.cols,
    //             rows: resp.rows
    //           });
    //         }
    //       });

    //       this.setState({ downloaded_file: file,file_loading:false })
    //     }).catch((error) => {
    //       message.error("Error Downloading file");
    //       this.setState({file_loading_error:true,file_loading:false})
    //       console.log("there was error", error)
    //     });
    // }, (error) => {
    //   showErrorInNotification(error);
    //   this.setState({file_loading_error:true,file_loading:false})
    // }).connect(props.domains.reports);

    this.mark_seen = RESTExecutor.patch().config({
      label: 'mark_seen_report'
    }).callbacks((success) => {
      this.setState({ seen: true })
    }, (error) => {
      // showErrorInNotification(error)
    }).connect(props.domains.reports);

    this.get_detail_report = RESTExecutor.detail().config({
      label: 'report_detail'
    }).callbacks((success) => {
      if (!success.result.seen) {
        this.mark_seen.forId(this.report_id).execute()
      }
      this.setState({
        detail_loading: false,
        report_detail: success.result,
        archived: success.result.archived
      })
      this.getUrl(this.report_id,{},true);
      // this.download_report.forId(this.report_id).execute()

    }, (error) => {
      this.setState({ detail_loading: false })

    }).forId(this.report_id).connect(props.domains.reports);

    this.archive_report = RESTExecutor.patch().config({
      label: 'archive_report'
    }).callbacks((success) => {
      // typeof props.onRefresh==='function'&&props.onRefresh()
      this.setState({ archived: true });
      try{this.props.history.goBack()}catch(e){}
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reports);

    this.unarchive_report = RESTExecutor.patch().config({
      label: 'unarchive_report'
    }).callbacks((success) => {
      this.setState({ archived: false })
      try{this.props.history.goBack()}catch(e){}
      // typeof props.onRefresh==='function'&&props.onRefresh()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reports);




    this.get_detail_report.execute()
    // this.download_report.forId(this.report_id).execute()

  };

  downloadFile = () => {
    FileSaver.saveAs(this.state.downloaded_file, "report.xlsx")
  }



  getUrl=(report_id,params,preview=false)=>{
    if(preview){
        this.get_file_url.forId(report_id).config({
            params:params
        }).callbacks((success)=>{
            this.setState({
                url:`${success.result.url}`
            })
        },(error)=>{
            showErrorInNotification(error);
        }).execute()
    }else{
        this.get_file_url.forId(report_id).config({
            params:params
        }).callbacks((success)=>{
            window.open(success.result.url, '_blank');
            try{
                this.loading_message();
              }catch(e){
        
              }
        },(error)=>{
            showErrorInNotification(error);
            try{
                this.loading_message();
              }catch(e){
        
              }
        }).execute()
    }
}


  render() {
    const { detail_loading, report_detail, archived } = this.state;
    if (detail_loading) {
      return <center><Spin /></center>
    }
    let seen = report_detail.seen;
    let owned = report_detail.report_type;
    let reference = report_detail.__references__ || {};
    let report_config = reference.report_id || {};

    let created_time=report_detail.created_datetime;

    // let archived=report_detail.archived;

    let get_detail_report_resp = this.get_detail_report.response();
    let get_file_url_resp=this.get_file_url.response();

    return (
      <ErrorWrapper error={get_detail_report_resp}
        onReload={() => {
          this.setState({
            detail_loading: true
          });
          this.get_detail_report.forId(this.report_id).execute();
        }}
      >
        <BasicHeader 
        title={archived?"Archived":"Inbox"}
        subtitle={report_config.name}
        subtitleType="Report Name"
        right={[
          <TransparentButton
              label={archived?"Unarchive":"Archive"}
              disabled={this.state.detail_loading} onClick={() => {
                if (this.state.archived) {
                  this.unarchive_report.forId(this.report_id).execute();
                } else {
                  this.archive_report.forId(this.report_id).execute()
                }
              }}
              icon={archived?<UnarchiveOutlined/>:<ArchiveOutlined/>}
              hint={archived?"Unarchive Report":"Archive Report"}
          />,
          <TransparentButton
          label="Download"
          disabled={get_file_url_resp.fetching} 
          onClick={() => {
            this.loading_message=message.loading(`Downloading ${report_config.name||""}`,0);
            this.getUrl(this.report_id,{},false)
          }} 
          icon={<CloudDownloadOutlined />}
          hint="Download Report"
      />

        ]}
        />

        <div className='filter-card'>
          <div style={{
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
            flexWrap:'nowrap'
          }}>
            <div style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              flexWrap:'nowrap'
            }}>
              <span>
                {created_time}
              </span>
              <Divider type='vertical'/>
              <span style={{
                color:COLORS.primary
              }}>
                {moment(created_time,"YYYY-MM-DD hh:mmA").fromNow()}
              </span>
            </div>

              <span style={{
                    fontSize:12,
                    textTransform:'uppercase',
                    color:COLORS.secondary
                }}>{owned}</span>
          </div>
        </div>
      
        <ErrorWrapper
        error={get_file_url_resp}
        onReload={() => {
            this.getUrl(this.report_id,{},true)
        }}
        >
           <div className='filter-card ' style={{
                    // padding:4
                }}>
                    {this.state.url&&<DebugFilePreview
                    hide_filter={true}
                    highlighter_downloaded={false}
                    url={this.state.url}
                    extension={"EXCEL"}
                    highlighter={[]}
                    />}
                
                </div>

        </ErrorWrapper>
      
     
        {/* <div className='default-card stick-content' style={{
          // height:'calc(100vh - 65px)',
          overflow:'scroll', 
        top:56}}>
          {this.state.file_loading_error?<center>
            <Button type='link' onClick={()=>{
              this.setState({
                file_loading_error:false
              });
              this.download_report.forId(this.report_id).execute();
            }}>Retry</Button>
          </center>:this.state.file_loading ? <div>
            <center><Spin /></center>
          </div> :
            <div>

              {this._renderAttachment()}
            </div>}
        </div>
     
      */}
      </ErrorWrapper>
    );
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.match.params.report_id !== prevProps.match.params.report_id) {
      this.report_id = this.props.match.params.report_id;
      this.setState({
        detail_loading: true,
        file_loading: true,
      })
      this.get_detail_report.forId(this.report_id).execute()
    };
  };

}

export default withDomains(ReportDetail, "reports");


